// @ts-nocheck THIS IS A GENERATED FILE, DO NOT EDIT
import * as PrivateSchemaTypes from '../../../graphql/private/PrivateSchemaTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@apolloHooksWithThrowingQuery';
const defaultOptions =  {}
export type CustomTranslationsTabQueryVariables = PrivateSchemaTypes.Exact<{
  locale: PrivateSchemaTypes.SupportedLocalesEnum;
  appSection: PrivateSchemaTypes.CustomTranslationsSectionEnum;
}>;


export type CustomTranslationsTabQuery = (
  { __typename?: 'Query' }
  & { organisation: (
    { __typename?: 'OrganisationModelGQLBase' }
    & Pick<PrivateSchemaTypes.OrganisationModelGqlBase, 'id'>
    & { customTranslationMessages: Array<(
      { __typename?: 'CustomTranslationModel' }
      & Pick<PrivateSchemaTypes.CustomTranslationModel, 'term' | 'translation' | 'locale' | 'app_section'>
    )> }
  ), backendTranslationMessages?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'BackendTranslations' }
    & { api: Array<(
      { __typename?: 'SingularTranslation' }
      & Pick<PrivateSchemaTypes.SingularTranslation, 'term' | 'definition' | 'reference'>
    )>, email: Array<(
      { __typename?: 'SingularTranslation' }
      & Pick<PrivateSchemaTypes.SingularTranslation, 'term' | 'definition' | 'reference'>
    )> }
  )> }
);

export type SetCustomTranslationMutationVariables = PrivateSchemaTypes.Exact<{
  customTranslation: PrivateSchemaTypes.CustomTranslationModelInput;
}>;


export type SetCustomTranslationMutation = (
  { __typename?: 'Mutation' }
  & { setCustomTranslation: (
    { __typename?: 'CustomTranslationModel' }
    & Pick<PrivateSchemaTypes.CustomTranslationModel, 'term' | 'translation' | 'locale'>
  ) }
);

export type DeleteTranslationMessageMutationVariables = PrivateSchemaTypes.Exact<{
  locale: PrivateSchemaTypes.SupportedLocalesEnum;
  term: PrivateSchemaTypes.Scalars['String'];
}>;


export type DeleteTranslationMessageMutation = (
  { __typename?: 'Mutation' }
  & { customTranslationMessage?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'CustomTranslationModel' }
    & Pick<PrivateSchemaTypes.CustomTranslationModel, 'delete'>
  )> }
);


export const CustomTranslationsTabDocument = gql`
    query CustomTranslationsTab($locale: SupportedLocalesEnum!, $appSection: CustomTranslationsSectionEnum!) {
  organisation {
    id
    customTranslationMessages(locale: $locale, appSection: $appSection) {
      term
      translation
      locale
      app_section
    }
  }
  backendTranslationMessages(locale: $locale) {
    api {
      term
      definition
      reference
    }
    email {
      term
      definition
      reference
    }
  }
}
    `;

/**
 * __useCustomTranslationsTabQuery__
 *
 * To run a query within a React component, call `useCustomTranslationsTabQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomTranslationsTabQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomTranslationsTabQuery({
 *   variables: {
 *      locale: // value for 'locale'
 *      appSection: // value for 'appSection'
 *   },
 * });
 */
export function useCustomTranslationsTabQuery(baseOptions: ApolloReactHooks.QueryHookOptions<CustomTranslationsTabQuery, CustomTranslationsTabQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CustomTranslationsTabQuery, CustomTranslationsTabQueryVariables>(CustomTranslationsTabDocument, options);
      }
export function useCustomTranslationsTabLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CustomTranslationsTabQuery, CustomTranslationsTabQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CustomTranslationsTabQuery, CustomTranslationsTabQueryVariables>(CustomTranslationsTabDocument, options);
        }
export type CustomTranslationsTabQueryHookResult = ReturnType<typeof useCustomTranslationsTabQuery>;
export type CustomTranslationsTabLazyQueryHookResult = ReturnType<typeof useCustomTranslationsTabLazyQuery>;
export type CustomTranslationsTabQueryResult = Apollo.QueryResult<CustomTranslationsTabQuery, CustomTranslationsTabQueryVariables>;
export const SetCustomTranslationDocument = gql`
    mutation setCustomTranslation($customTranslation: CustomTranslationModelInput!) {
  setCustomTranslation(customTranslation: $customTranslation) {
    term
    translation
    locale
  }
}
    `;
export type SetCustomTranslationMutationFn = Apollo.MutationFunction<SetCustomTranslationMutation, SetCustomTranslationMutationVariables>;

/**
 * __useSetCustomTranslationMutation__
 *
 * To run a mutation, you first call `useSetCustomTranslationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetCustomTranslationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setCustomTranslationMutation, { data, loading, error }] = useSetCustomTranslationMutation({
 *   variables: {
 *      customTranslation: // value for 'customTranslation'
 *   },
 * });
 */
export function useSetCustomTranslationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SetCustomTranslationMutation, SetCustomTranslationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SetCustomTranslationMutation, SetCustomTranslationMutationVariables>(SetCustomTranslationDocument, options);
      }
export type SetCustomTranslationMutationHookResult = ReturnType<typeof useSetCustomTranslationMutation>;
export type SetCustomTranslationMutationResult = Apollo.MutationResult<SetCustomTranslationMutation>;
export type SetCustomTranslationMutationOptions = Apollo.BaseMutationOptions<SetCustomTranslationMutation, SetCustomTranslationMutationVariables>;
export const DeleteTranslationMessageDocument = gql`
    mutation deleteTranslationMessage($locale: SupportedLocalesEnum!, $term: String!) {
  customTranslationMessage(locale: $locale, term: $term) {
    delete
  }
}
    `;
export type DeleteTranslationMessageMutationFn = Apollo.MutationFunction<DeleteTranslationMessageMutation, DeleteTranslationMessageMutationVariables>;

/**
 * __useDeleteTranslationMessageMutation__
 *
 * To run a mutation, you first call `useDeleteTranslationMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTranslationMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTranslationMessageMutation, { data, loading, error }] = useDeleteTranslationMessageMutation({
 *   variables: {
 *      locale: // value for 'locale'
 *      term: // value for 'term'
 *   },
 * });
 */
export function useDeleteTranslationMessageMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteTranslationMessageMutation, DeleteTranslationMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteTranslationMessageMutation, DeleteTranslationMessageMutationVariables>(DeleteTranslationMessageDocument, options);
      }
export type DeleteTranslationMessageMutationHookResult = ReturnType<typeof useDeleteTranslationMessageMutation>;
export type DeleteTranslationMessageMutationResult = Apollo.MutationResult<DeleteTranslationMessageMutation>;
export type DeleteTranslationMessageMutationOptions = Apollo.BaseMutationOptions<DeleteTranslationMessageMutation, DeleteTranslationMessageMutationVariables>;